import { render, staticRenderFns } from "./PlayerProfile.vue?vue&type=template&id=71592fd2&"
import script from "./PlayerProfile.vue?vue&type=script&lang=js&"
export * from "./PlayerProfile.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports